import {
  ChargeAsesorApi,
  ChargeContactApi,
} from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";
import { getContactChargeUpdatenObject } from "../Data/ContactChargeWrappers";

export const updateChargeContactApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${ChargeContactApi}/${id}`,
      getContactChargeUpdatenObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
